import PageHeader from 'src/core/ui/PageHeader';
import Footer from 'src/core/ui/helpers/Footer';
import ContentCardsContainer, { CardType, ContentCard } from 'src/core/ui/ContentCard';
import { CustomDataGrid } from 'src/core/tables/CustomDataGrid';
import { generateTablePageButtons } from 'src/core/tables/generateTablePageButtons';
import { useOrderOriginsTable } from 'src/pages/settings/admin/orderOrigins/useOrderOriginsTable';

export const OrderOriginsTablePage = () => {
    const [columns, tableSettings] = useOrderOriginsTable();
    return (
        <>
            <PageHeader {...{
                title: "Order Origins", subTitle: "View order origins and their channel types",
                components: generateTablePageButtons(tableSettings),
            }} />
            <ContentCardsContainer>
                <ContentCard cardId="Order Origins" cardTypes={[CardType.noHeader]} contentPadding={0}>
                    <CustomDataGrid columns={columns} tableSettings={tableSettings} />
                </ContentCard>
            </ContentCardsContainer>
            <Footer />
        </>
    );
};

export default OrderOriginsTablePage;
